export default __webpack_public_path__ + "static/media/logo.dfef893c.svg";